(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-portraits-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cp-hero-video')) {
    customElements.define('cp-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.cp-hero__video-stage');
        this.button = this.querySelector('button');
        if (!this.stage || !this.button) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.breakpoint = window.matchMedia('(max-width: 749px)');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.ended = false;
        this.button.hidden = false;

        this.updateButton = () => {
          const paused = !this.video || this.video.paused || this.ended;
          this.button.dataset.paused = String(paused);
          this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        };

        this.setVideoVisible = (visible) => {
          if (this.video) this.video.classList.toggle('is-visible', visible);
        };

        // Desktop autoplays (see mount()); the button is therefore a PAUSE control
        // on arrival, and a resume control after the visitor has paused it.
        this.play = () => {
          if (!this.video) return;
          this.ended = false;
          this.video.play().catch(() => this.backToCover());
          this.updateButton();
        };

        // Failed to load, or autoplay blocked: fade back to the cover image.
        // 'ended' no longer routes here — the loop attribute keeps it playing.
        this.backToCover = () => {
          this.ended = true;
          this.setVideoVisible(false);
          if (this.video) {
            this.video.pause();
            if (this.video.currentTime) this.video.currentTime = 0;
          }
          this.updateButton();
        };

        // 揭示分两步，为的是让这次交叉溶解不可能被浏览器静默跳过。
        //
        // 坑在哪：视频被缓存时，'playing' 可能在「插入 video 元素」的同一帧内就触发。
        // 这时浏览器一次样式计算就把 opacity 直接算到终值，中间从来没有存在过
        // opacity: 0 这个状态 —— 没有起点就没有过渡，0.7s 淡入退化成硬切。
        // 现象就是「没有淡入」，而代码看起来完全正确。
        //
        // 所以：
        //   ① void offsetWidth 强制立刻做一次样式计算，把 opacity: 0 这个起点坐实；
        //   ② 再等下一帧（rAF）才翻 class —— 此刻浏览器已经有真实的起始值可以插值。
        // 两步缺一不可：只做 ① 不保证中间隔了一次绘制，只做 ② 不保证起点被算过。
        // 代价是揭示晚一帧（约 16ms），肉眼不可见。
        this.revealVideo = () => {
          const video = this.video;
          if (!video) return;
          void video.offsetWidth;
          requestAnimationFrame(() => {
            // 这一帧里可能已经转屏/卸载（releaseVideo）或重新 mount 过了。
            if (video !== this.video) return;
            this.setVideoVisible(true);
          });
        };

        this.mount = () => {
          const template = this.querySelector('template[data-video-variant="desktop"]');
          if (!template) return;
          this.releaseVideo();
          this.video = template.content.querySelector('video').cloneNode(true);
          this.video.muted = true;
          this.videoController = new AbortController();
          const videoOptions = { signal: this.videoController.signal };
          // 'playing' — not 'loadeddata' or 'canplay' — is what triggers the
          // cross-dissolve: it means real frames are already moving, so a frozen
          // first frame is never what fades in. The actual reveal goes through
          // revealVideo() — 直接在这里 setVideoVisible 会被同帧合并掉，淡入消失。
          this.video.addEventListener('playing', () => {
            this.revealVideo();
            this.updateButton();
          }, videoOptions);
          this.video.addEventListener('pause', this.updateButton, videoOptions);
          this.video.addEventListener('error', this.backToCover, videoOptions);
          this.video.querySelectorAll('source').forEach((source) => {
            source.addEventListener('error', this.backToCover, videoOptions);
          });
          this.stage.append(this.video);
          this.updateButton();

          // Autoplay: the whole point on desktop. Mobile never reaches mount(),
          // so it still downloads nothing. Reduced-motion users get no autoplay and
          // simply keep looking at the cover image. If the browser refuses,
          // play()'s catch falls back to the cover image too.
          if (!this.reduceMotion.matches) this.play();
        };

        // Mobile never loads the video — not mounting it means zero bytes fetched.
        this.syncBreakpoint = () => {
          if (this.breakpoint.matches) {
            this.releaseVideo();
            this.button.hidden = true;
            return;
          }
          this.ended = false;
          this.button.hidden = false;
          this.mount();
        };

        this.button.addEventListener('click', () => {
          if (!this.video || this.video.paused) {
            this.play();
          } else {
            this.video.pause();
            this.updateButton();
          }
        }, options);

        this.breakpoint.addEventListener('change', this.syncBreakpoint, options);
        // Hidden: pause, and remember whether it was actually running. Visible
        // again: resume only in that case. Without the resume half, an autoplaying
        // hero would stay frozen for the rest of the visit after one tab switch.
        this.wasPlaying = false;
        document.addEventListener('visibilitychange', () => {
          if (!this.video) return;
          if (document.hidden) {
            this.wasPlaying = !this.video.paused;
            if (this.wasPlaying) this.video.pause();
          } else if (this.wasPlaying) {
            this.wasPlaying = false;
            this.play();
          }
        }, options);

        this.syncBreakpoint();
      }

      releaseVideo() {
        this.videoController?.abort();
        const video = this.video;
        this.video = null;
        if (!video) return;
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        video.load();
        video.remove();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.releaseVideo();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-upload-now"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const buttons = document.querySelectorAll('[data-floating-upload-now]');

    buttons.forEach((button) => {
      let pointerId = null;
      let startX = 0;
      let startY = 0;
      let startLeft = 0;
      let startTop = 0;
      let moved = false;
      let dragged = false;

      const margin = 12;
      const visiblePeek = 18;

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

      const getBounds = () => {
        const rect = button.getBoundingClientRect();
        return {
          rect,
          maxLeft: window.innerWidth - rect.width - margin,
          maxTop: window.innerHeight - rect.height - margin - 72,
        };
      };

      const setPosition = (left, top) => {
        button.style.setProperty('--floating-upload-x', `${left}px`);
        button.style.setProperty('--floating-upload-y', `${top}px`);
        button.style.setProperty('--floating-upload-bottom', 'auto');
      };

      const expand = () => {
        button.classList.remove('is-edge-hidden');
        button.setAttribute('aria-expanded', 'true');
      };

      const collapseToEdge = () => {
        const { rect, maxLeft, maxTop } = getBounds();
        const currentLeft = rect.left;
        const currentTop = clamp(rect.top, margin, maxTop);
        const edge = currentLeft + rect.width / 2 < window.innerWidth / 2 ? 'left' : 'right';
        const edgeLeft = edge === 'left' ? margin : maxLeft;

        button.dataset.edge = edge;
        setPosition(edgeLeft, currentTop);
        button.classList.add('is-edge-hidden');
        button.setAttribute('aria-expanded', 'false');
      };

      const onPointerMove = (event) => {
        if (!mobileQuery.matches || event.pointerId !== pointerId) {
          return;
        }

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (Math.abs(deltaX) > 4 || Math.abs(deltaY) > 4) {
          moved = true;
          dragged = true;
          button.classList.add('is-dragging');
          expand();
        }

        if (!moved) {
          return;
        }

        event.preventDefault();

        const { maxLeft, maxTop } = getBounds();
        const nextLeft = clamp(startLeft + deltaX, margin - visiblePeek, maxLeft + visiblePeek);
        const nextTop = clamp(startTop + deltaY, margin, maxTop);
        setPosition(nextLeft, nextTop);
      };

      const onPointerUp = (event) => {
        if (event.pointerId !== pointerId) {
          return;
        }

        pointerId = null;
        button.releasePointerCapture?.(event.pointerId);
        button.classList.remove('is-dragging');

        if (dragged) {
          event.preventDefault();
          collapseToEdge();
          setTimeout(() => {
            dragged = false;
          }, 0);
        }
      };

      button.addEventListener('pointerdown', (event) => {
        if (!mobileQuery.matches) {
          return;
        }

        pointerId = event.pointerId;
        moved = false;
        dragged = false;
        button.setPointerCapture?.(event.pointerId);

        const rect = button.getBoundingClientRect();
        startX = event.clientX;
        startY = event.clientY;
        startLeft = rect.left;
        startTop = rect.top;
      });

      button.addEventListener('pointermove', onPointerMove);
      button.addEventListener('pointerup', onPointerUp);
      button.addEventListener('pointercancel', onPointerUp);

      button.addEventListener('click', (event) => {
        if (!mobileQuery.matches) {
          return;
        }

        if (dragged) {
          event.preventDefault();
          return;
        }

        if (button.classList.contains('is-edge-hidden')) {
          event.preventDefault();
          expand();
        }
      });

      window.addEventListener('resize', () => {
        if (!mobileQuery.matches || !button.classList.contains('is-edge-hidden')) {
          return;
        }

        collapseToEdge();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsCover = this.getAttribute('data-sticky-type') === 'cover-logo-size';

      this.headerBounds = {};
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if (this.headerIsCover) {
        this.header.classList.add('shopify-section-header-cover');
        
        const stickyHeader = document.querySelector('.header-wrapper');
        stickyHeader.classList.add('header-hovered');

        window.addEventListener('scroll', () => {
          let scrollTop =  document.documentElement.scrollTop;

          if (scrollTop > 650) {
            stickyHeader.classList.remove('header-hovered');
          } else {
            stickyHeader.classList.add('header-hovered');
          }
        });

      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
				if (disclosure) {
					disclosure.close()
				}
			}
			);
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-style-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-style-finder')) {
    customElements.define('lp-style-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.connected) return;
        if (!this.querySelector('[data-product-grid]')) {
          this.connectFrame = requestAnimationFrame(() => this.connectedCallback());
          return;
        }
        this.connected = true;
        this.designMode = this.dataset.designMode === 'true' || window.Shopify?.designMode === true;
        this.storageKey = ['lp-style-finder', this.dataset.themeId, this.dataset.sectionId, window.location.pathname, this.designMode ? 'editor' : 'storefront'].join(':');
        this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
        this.craftButtons = Array.from(this.querySelectorAll('[data-craft-button]'));
        this.filterButtons = Array.from(this.querySelectorAll('[data-filter-button]'));
        this.grid = this.querySelector('[data-product-grid]');
        this.footer = this.querySelector('[data-products-footer]');
        this.moreButton = this.querySelector('[data-show-more]');
        this.showing = this.querySelector('[data-showing-count]');
        this.state = this.readState();
        this.render();
        this.onClick = (event) => this.handleClick(event);
        this.onBlockSelect = (event) => {
          const block = this.querySelector(`[data-block-id="${CSS.escape(event.detail.blockId)}"]`);
          if (!block) return;
          this.selectCraft(block.dataset.craftKey, false);
          if (block.matches('[data-filter-button]')) this.selectFilter(block.dataset.filterId);
        };
        this.onPageHide = () => this.saveState();
        this.onPageShow = (event) => {
          if (event.persisted) {
            this.resumeOnReturn = false;
            try { sessionStorage.setItem(this.storageKey, JSON.stringify({ state: this.state, resume: false })); } catch (_) {}
            this.cancelRestore();
            this.pendingScroll = null;
            return;
          }
          this.restoreScroll();
        };
        this.onUserInput = () => {
          this.cancelRestore();
          this.pendingScroll = null;
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        window.addEventListener('pagehide', this.onPageHide);
        window.addEventListener('pageshow', this.onPageShow);
        window.addEventListener('pointerdown', this.onUserInput, { passive: true });
        window.addEventListener('wheel', this.onUserInput, { passive: true });
        window.addEventListener('keydown', this.onUserInput);
        this.pendingScroll = this.state.craft ? this.state.scrollY : null;
        if (document.readyState === 'complete') this.restoreScroll();
      }

      disconnectedCallback() {
        this.connected = false;
        cancelAnimationFrame(this.connectFrame);
        this.cancelRestore();
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('pagehide', this.onPageHide);
        window.removeEventListener('pageshow', this.onPageShow);
        window.removeEventListener('pointerdown', this.onUserInput);
        window.removeEventListener('wheel', this.onUserInput);
        window.removeEventListener('keydown', this.onUserInput);
      }

      readState() {
        const clean = { version: 3, step: 1, craft: null, crafts: {}, scrollY: 0 };
        let saved;
        let cached;
        try { saved = history.state?.lpStyleFinder?.[this.storageKey]; } catch (_) {}
        try { cached = JSON.parse(sessionStorage.getItem(this.storageKey)); } catch (_) {}
        if (!saved) {
          const navigation = performance.getEntriesByType('navigation')[0]?.type;
          if (cached?.resume || navigation === 'back_forward' || navigation === 'reload') saved = cached?.state;
        }
        this.resumeOnReturn = false;
        if (cached?.resume) {
          try { sessionStorage.setItem(this.storageKey, JSON.stringify({ state: cached.state, resume: false })); } catch (_) {}
        }
        if (saved?.version !== 3) saved = null;
        this.craftButtons.forEach((button) => {
          const key = button.dataset.craftKey;
          const filters = this.filterButtons.filter((filter) => filter.dataset.craftKey === key).map((filter) => filter.dataset.filterId);
          const allowed = key === 'gift' ? ['keepsakes'] : filters;
          const stored = saved?.crafts?.[key];
          const entry = { filter: allowed.includes(stored?.filter) ? stored.filter : allowed[0], expanded: {} };
          allowed.forEach((filter) => {
            const count = Number(stored?.expanded?.[filter]);
            entry.expanded[filter] = Number.isInteger(count) && count >= 4 ? Math.min(count, this.cards.length + 4) : 4;
          });
          clean.crafts[key] = entry;
        });
        if (Object.hasOwn(clean.crafts, saved?.craft)) {
          clean.craft = saved.craft;
          clean.step = saved.step === 1 ? 1 : 2;
        }
        if (Number.isFinite(saved?.scrollY) && saved.scrollY >= 0) clean.scrollY = saved.scrollY;
        return clean;
      }

      saveState(resume = this.resumeOnReturn || false) {
        if (!this.state) return;
        this.state.scrollY = window.scrollY;
        try {
          const current = history.state || {};
          history.replaceState({ ...current, lpStyleFinder: { ...current.lpStyleFinder, [this.storageKey]: this.state } }, '');
        } catch (_) {}
        try { sessionStorage.setItem(this.storageKey, JSON.stringify({ state: this.state, resume })); } catch (_) {}
      }

      handleClick(event) {
        if (!(event.target instanceof Element)) return;
        const control = event.target.closest('[data-craft-button], [data-filter-button], [data-show-more], [data-product-card]');
        if (!control || control.closest('lp-style-finder') !== this) return;
        this.onUserInput();
        if (control.matches('[data-craft-button]')) this.selectCraft(control.dataset.craftKey);
        else if (control.matches('[data-filter-button]')) this.selectFilter(control.dataset.filterId);
        else if (control.matches('[data-show-more]')) this.showMore();
        else { this.resumeOnReturn = !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0; this.saveState(); }
      }

      selectCraft(key, focus = true) {
        if (!Object.hasOwn(this.state.crafts, key)) return;
        this.state.craft = key;
        this.state.step = 2;
        this.render();
        if (focus) this.focusStep('[data-products-heading]');
        this.saveState();
      }

      focusStep(selector) {
        this.querySelector(selector).focus({ preventScroll: true });
        this.querySelector('[data-products-step]').scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          block: 'start'
        });
      }

      selectFilter(id) {
        const entry = this.state.crafts[this.state.craft];
        if (!entry || !Object.hasOwn(entry.expanded, id)) return;
        entry.filter = id;
        this.render();
        this.saveState();
      }

      matchingCards() {
        const craft = this.state.craft;
        const filter = this.state.crafts[craft]?.filter;
        return this.cards.filter((card) => card.dataset.craftKeys.split(/\s+/).includes(craft) && (craft === 'gift' || card.dataset.seriesIds.split(/\s+/).includes(filter)));
      }

      render() {
        const craft = this.state.craft;
        const entry = this.state.crafts[craft];
        this.craftButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.craftKey === craft)));
        this.filterButtons.forEach((button) => {
          button.hidden = button.dataset.craftKey !== craft;
          button.setAttribute('aria-pressed', String(button.dataset.filterId === entry?.filter));
        });
        this.querySelector('[data-initial-help]').hidden = Boolean(craft);
        this.querySelector('[data-filters]').hidden = !craft || craft === 'gift';
        this.grid.hidden = !craft;
        this.footer.hidden = !craft;
        this.querySelectorAll('[data-progress]').forEach((item) => {
          if (Number(item.dataset.progress) === (craft ? 2 : 1)) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
        });
        const matches = craft ? this.matchingCards() : [];
        const shown = entry ? Math.min(entry.expanded[entry.filter], matches.length) : 0;
        const visible = new Set(matches.slice(0, shown));
        this.cards.forEach((card) => { card.hidden = !visible.has(card); });
        this.moreButton.hidden = !craft || shown >= matches.length;
        this.querySelector('[data-empty]').hidden = !craft || matches.length > 0;
        this.showing.textContent = this.dataset.showingTemplate.replace('[shown]', String(shown)).replace('[total]', String(matches.length));
        return { matches, shown };
      }

      showMore() {
        const entry = this.state.crafts[this.state.craft];
        if (!entry) return;
        const matches = this.matchingCards();
        const previous = Math.min(entry.expanded[entry.filter], matches.length);
        const top = window.scrollY;
        entry.expanded[entry.filter] = Math.min(previous + 12, matches.length);
        this.render();
        matches[previous]?.focus({ preventScroll: true });
        window.scrollTo({ top, left: window.scrollX, behavior: 'instant' });
        this.saveState();
      }

      cancelRestore() {
        cancelAnimationFrame(this.restoreFrame);
        cancelAnimationFrame(this.restoreFrameTwo);
      }

      restoreScroll() {
        if (this.pendingScroll === null || this.pendingScroll === undefined) return;
        this.cancelRestore();
        this.restoreFrame = requestAnimationFrame(() => {
          this.restoreFrameTwo = requestAnimationFrame(() => {
            if (!this.isConnected || this.pendingScroll === null) return;
            const top = this.pendingScroll;
            this.pendingScroll = null;
            window.scrollTo({ top, left: window.scrollX, behavior: 'instant' });
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
